<template>
  <div class="notfound-page-wrapper">
    <div class="notfound-page__logo">
      <img :src="logo" alt="logo" />
      <img :src="assistant" alt="assistant" />
    </div>
    <div class="notfound-page__content">
      <h1>{{ t('page.notfound-text') }}</h1>
      <router-link to="/">{{ t('menu.new-chat') }}</router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import logo from '@/assets/icons/menu/logo.svg'
import assistant from '@/assets/icons/menu/assistant.svg'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<style lang="scss" scoped>
.notfound-page-wrapper {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .notfound-page {
    display: flex;
    &__logo {
      display: flex;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px 24px;
      gap: 8px;
    }

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
